import { Store } from "./store";
import ContentFile from "../content";
import { Core } from "./core";
import { createWrapper } from "@upandgo/scorm-wrapper";

export const store = new Store(ContentFile);
export const core = new Core(store, createWrapper);
